import { Directive, ElementRef, OnInit, HostListener, Input } from '@angular/core';

import { DragService, DragEventType } from '../services/drag.service';

import { ControlSpecification } from '../types/specification.types';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[dfDrag]'
})
export class DragDirective implements OnInit {
  @Input('dfDrag') specification: ControlSpecification;

  constructor(public el: ElementRef, private dragService: DragService) {}
  public isDown = false;

  public disX: any; // è®°å½é¼ æ ç¹å»äºä»¶çä½ç½® X

  public disY: any; // è®°å½é¼ æ ç¹å»äºä»¶çä½ç½® Y

  private isBegin: boolean = false;

  // ç¹å»äºä»¶
  @HostListener('mousedown', ['$event']) onMousedown(event: any) {
    if (event.button !== 0) {
      return;
    }
    this.isDown = true;
    this.isBegin = false;
    this.disX = event.clientX;
    this.disY = event.clientY;
  }

  // çå¬documentç§»å¨äºä»¶äºä»¶
  @HostListener('document:mousemove', ['$event']) onMousemove(event: any) {
    // å¤æ­è¯¥åç´ æ¯å¦è¢«ç¹å»äºã
    if (this.isDown) {
      if (!this.isBegin) {
        this.isBegin = true;
        this.dragService.sendDragEvent({ eventType: DragEventType.Begin, specification: this.specification });
      }
    }
  }

  // çå¬documentç¦»å¼äºä»¶
  @HostListener('document:mouseup', ['$event']) onMouseup(event: any) {
    // åªç¨å½åç´ ç§»å¨è¿äºï¼ç¦»å¼å½æ°ä½æä¼è§¦åã
    this.isBegin = false;
    if (this.isDown) {
      this.dragService.sendDragEvent({ eventType: DragEventType.End });
      this.isDown = false;
    }
  }

  ngOnInit() {}
}
